/**
 * Dear Maintainer,
 * this mixin helps to handle list fields in revision.
 * Challenge:
 * - We want to overwrite fields with revisions
 * - We want to be able to set empty list on list fiels in revision
 * - We want to be able to save revisions without chaning anything
 * - We cannot set null to list fields since db would set a default value.
 * => since we cannot store revisions with null for list fields,
 * we need to write the same value from original product
 * into the revision list fields. Thats what this mixin does.
 */
export default ({ listFields }) => ({
  methods: {
    /**
     * Resets the media field, if there is no difference to the product.
     * Otherwise, the user would se it as overwrite.
     */
    handleRevisionListFieldDiff() {
      // eslint-disable-next-line no-restricted-syntax
      for (const field of listFields) {
        if (Array.isArray(this.fields.values[field])
            && this.fields.values[field].length === 0) {
          // eslint-disable-next-line no-continue
          continue;
        }
        const lhs = JSON.stringify(this.fields.values[field]);
        const rhs = JSON.stringify(this.product[field]);
        if (lhs === rhs) {
          this.fields.values[field] = null;
        }
      }
    },
    setExistingListFieldsAsDefault() {
      // eslint-disable-next-line no-restricted-syntax
      for (const field of listFields) {
        const mediaOverwritten = Array.isArray(this.fields.values[field]);
        if (Array.isArray(this.product[field]) && !mediaOverwritten) {
          this.fields.values[field] = this.product[field];
        }
      }
    },
    submitWithExistingListFieldValues() {
      this.setExistingListFieldsAsDefault();
      this.submit();
    },
  },
});



// WEBPACK FOOTER //
// ./mixins/ProductRevisionFormHelper.js